<div>
    <div class="d-flex">
        <custom-togle [(value)]="ehEstrangeiro" (toggleChange)="updateEhEstrangeiro($event)"></custom-togle>
        <span class="ml-1">Sou estrangeiro</span>
    </div>
    <div class="mb-4 mt-4">
        <label for="nomeOrPassaporte" class="form-label required">{{ehEstrangeiro ? 'Passaporte' : 'CPF'}}</label>
        <input type="text" class="form-control" name="nomeOrPassaporte" [maxlength]="ehEstrangeiro ? 150 : 14"
            [mask]="!ehEstrangeiro ? '000.000.000-00' : ''" [(ngModel)]="cpfOrPassaporte"
            #nomeOrPassaporteModel="ngModel" #nomeOrPassaporteEl id="nomeOrPassaporte" required
            placeholder="Digite aqui" />
        <abp-validation-summary [control]="nomeOrPassaporteModel"
            [controlEl]="nomeOrPassaporteEl"></abp-validation-summary>
    </div>
</div>